import { SessionAction } from "../session/sessionTypes";

export interface ISubmitLoginAction {
  type: LoginActionTypes.SUBMIT_LOGIN;
  token: string;
}

export interface ILoginSuccessAction {
  type: LoginActionTypes.LOGIN_SUCCESS;
  payload: {};
}

export interface IQRSignupSuccessAction {
  type: LoginActionTypes.QR_SIGNUP_SUCCESS;
  payload: {};
}

export interface ILoginDone {
  type: LoginActionTypes.LOGIN_DONE;
}

export interface ILoginFailedAction {
  type: LoginActionTypes.LOGIN_FAILED;
}
export interface ILogOutAction {
  type: LoginActionTypes.LOGOUT;
}

export type LoginActions =
  | ISubmitLoginAction
  | ILoginSuccessAction
  | ILoginFailedAction
  | ILoginSuccessAction
  | ILoginFailedAction
  | ILoginDone
  | ILogOutAction
  | IQRSignupSuccessAction;

export interface ILoginState {
  loading: Iloading;
  loggedIn: boolean;
}

export interface Iloading {
  status: "inactive" | "active" | "finished" | "error";
  description: string;
}

export enum LoginActionTypes {
  SUBMIT_LOGIN = "login/submit",
  QR_SIGNUP_SUCCESS = "login/signup_qr_success",
  LOGIN_SUCCESS = "login/success",
  LOGIN_FAILED = "login/failed",
  LOGIN_DONE = "login/done",
  LOGOUT = "login/logout",
}

// export type ReduxActions = LoginActions | ScafoldingActions | SessionAction
export type ReduxActions = LoginActions | SessionAction;
